export function noop() { }
export function generateId() {
    const id = window.crypto !== undefined
        ? window.crypto.randomUUID()
        : Math.random().toString(36).substr(2, 9);
    return id;
}
//# sourceMappingURL=misc.js.map